<template>
  <v-layout ma-0>
    <v-flex class="tile-item d-flex">
      <v-layout class="tile-item-layout" align-center pr-0 pr-sm-2>
        <v-flex class="tile-icon d-flex m-auto mb-3 mb-md-auto " xs12 sm2 pl-3 >
          <Icon :icon="icon" class="display-m-40" />
        </v-flex>
        <v-flex class="tile-item-align" xs12 sm10>
          <a :href="item.link" class="d-block black--text">
            <h3 class="display-20-16 bold">{{ item.title }}</h3>
            <div class="hidden-sm-and-down item-teaser" v-html="item.description"></div>
          </a>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>


<script>
import Icon from '@/components/Wrappers/Icon/Icon'

export default {
  components: { Icon },
  props: {
    item: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      reqired: false
    }
  }
}
</script>

<style scoped>
.tile-item-layout {
  flex-direction: row;
}

.tile-item-align {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  text-align: right;
  margin: auto;
}

.tile-item-align h3 {
  height: 25px;
}

a {
  color: inherit;
  text-decoration: none;
}

.tile-item {
  cursor: pointer;
  color: #000;
  text-decoration: none;
}

.item-teaser {
  width: 90%;
}

@media screen and (max-width: 1280px) {
}

@media screen and (max-width: 960px) {
  .tile-icon {
    padding: 0px !important;
  }

  .tile-item-layout {
    flex-direction: column;
  }

  .tile-item-align {
    text-align: center;
  }

  .tile-item-align h3 {
    height: 40px;
  }
}
</style>
